<script setup lang="ts">
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header2 from '@/components/base/typography/Header2.vue';

const jeffJa = nutshell['static_img/about-us/jeff_ja.jpg'];
const jeffreyAtUam1 = nutshell['static_img/about-us/JeffreyatUAM1.jpg'];
</script>

<template>
  <div class="flex flex-col gap-4">
    <Header2>Our Community</Header2>
    <BaseBodyText class="mt-2">
      As a small, third generation family business, I can speak sincerely when I express our
      commitment to the communities we live and work in.
    </BaseBodyText>

    <BaseBodyText>
      Setting political and theological ideologies aside, the moral fabric of our society continues
      to change. Each day our kids are faced with bigger challenges and distractions. Over time I
      will highlight more of the ways our Nutty Nuts.com Family gets involved in the community, but
      I wanted to focus on a couple of great organizations out there that invest in and make a
      tremendous impact upon our kids.
    </BaseBodyText>

    <BaseBodyText>
      The first is the
      <a href="http://www.bbbsa.org/" target="_blank">Big Brother Big Sister</a> program. I was a
      Big Brother to a wonderful 9 year old boy. This is an enriching and rewarding program for not
      only the "little," but as much so for the "big."
    </BaseBodyText>

    <BaseBodyText>
      The second is <a href="http://www.ja.org/" target="_blank">Junior Achievement</a>. I went into
      both a 2nd grade and 8th grade classroom and used prescribed lesson plans to teach children
      about business. The kids were adorable, were so receptive and appreciative, and it was a lot
      of fun for everyone! Here's a picture below of my 2nd grade class.
    </BaseBodyText>

    <div class="p-4 text-center bg-nuts-neutral-100">
      <img alt="Jeffrey with the kids in his 2nd grade class" :src="jeffJa" />
    </div>

    <BaseBodyText>
      The third is <a href="http://www.nycares.org/" target="_blank">NY Cares</a>. This is a great
      one-off experience to perform a wide range of volunteer opportunities. My favorite experience
      was going wall climbing with a group of kids from the Chelsea Recreation Center. It was a ton
      of fun and the kids had a blast!
    </BaseBodyText>

    <BaseBodyText>
      I also love to teach kids about entrepreneurship! This is me with aspiring entrepreneurs at
      UAM High School's Career Day.
    </BaseBodyText>

    <div class="p-4 text-center bg-nuts-neutral-100">
      <img alt="Jeffrey at UAM High School's Career Day" :src="jeffreyAtUam1" />
    </div>

    <BaseBodyText>
      I also read with children in a homeless shelter through the Makor Book Club.
    </BaseBodyText>
  </div>
</template>
